import React from 'react';

import OpenTenders from './OpenTenders';
import CloseTenders from './CloseTenders';
import CreateTenderForm from './CreateTenderForm';

export const OPEN_FILTERS = { is_open: { value: true } };
export const CLOSE_FILTERS = { is_closed: { value: true } };
export const MY_SUBMISSIONS_FILTERS = { have_responded: { value: true } };

export const TENDERS_TABS = {
  open: {
    text: 'Below is a list of all our live projects.',
    filters: OPEN_FILTERS
  },
  closed: {
    text:
      'The below projects are closed. To view a particular project in detail, click view.',
    filters: CLOSE_FILTERS
  },
  'my-projects': {
    text: 'Below you can see a list of tenders that you have submitted.',
    filters: MY_SUBMISSIONS_FILTERS
  }
};

export const CREATE_TENDERS_PAGE_TABS = {
  create: {
    component: CreateTenderForm,
    title: 'Create a Project'
  },
  open: {
    component: OpenTenders,
    title: 'Open Projects'
  },
  closed: {
    component: CloseTenders,
    title: 'Closed Projects'
  },
  drafts: {
    component: <div>To be implemented</div>,
    title: 'Drafts'
  }
};
